import { useAuth } from "../context/AuthContext";

export default function WhatsAppBadge() {
  const { user } = useAuth();

  if (user) return null;

  return (
    <a id="whatsapp-badge" href="https://wa.me/923017196699" target="_blank">
      <span className="wa-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20">
              <path fill="#25D366"
                  d="M16 3C9.4 3 4 8.2 4 14.7c0 2.6.7 5 2.1 7.1L4 29l7.5-2c2 .6 3.1.8 4.5.8 6.6 0 12-5.2 12-11.7S22.6 3 16 3zm0 21c-1.3 0-2.5-.2-3.7-.7l-.3-.1-4.5 1.2 1.2-4.3-.2-.3c-1.2-1.9-1.9-4.1-1.9-6.3C6.6 8.4 11 4.5 16 4.5s9.4 3.9 9.4 8.7S21 24 16 24zm5.2-6.3c-.3-.2-1.6-.8-1.9-.9-.3-.1-.5-.2-.7.2-.2.3-.8.9-1 .1-.2-.8-.6-.7-1-.9-.4-.2-1.3-.5-2.5-1.6-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.7.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.2 3.4 1.3 3.6c.2.2 2.3 3.5 5.6 4.9.8.3 1.4.5 1.9.6.8.2 1.5.2 2 .1.6-.1 1.6-.7 1.8-1.3.2-.6.2-1.2.1-1.3-.1-.1-.3-.2-.6-.4z" />
          </svg>
      </span>

      <span className="wa-text">Chat with us</span>
    </a>
  );
}